import { render, staticRenderFns } from "./BackwardForward.vue?vue&type=template&id=6b751916&scoped=true&"
import script from "./BackwardForward.vue?vue&type=script&lang=js&"
export * from "./BackwardForward.vue?vue&type=script&lang=js&"
import style0 from "./BackwardForward.vue?vue&type=style&index=0&id=6b751916&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b751916",
  null
  
)

export default component.exports